{
  "loading": "Loading...",
  "error": "Error",
  "success": "Success",
  "cancel": "Cancel",
  "save": "Save",
  "close": "Close",
  "yes": "Yes",
  "no": "No",
  "required": "Required",
  "optional": "Optional",
  "conditional": "Conditional",
  "submitted": "Submitted",
  "approved": "Approved",
  "pending": "Pending"
}